import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { IColuna } from "app/types/IColuna";
import { Markup, produtoMarkupAlterado } from "app/types/Markup";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import globalMU from "globalMU";
import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { substituirItemEmArray } from "substituirItemEmArray";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { SenhaMarkup } from "./senha-markup/SenhaMarkup";
import { TelaMarkup, TelaMarkupContext } from "./TelaMarkup";
import { alterarPrecoItemSimulacaoMarkup } from "app/use-cases/orcamento/alterarPrecoItemSimulacaoMarkup";
import { Permissao } from "app/types/Permissao";

export const PermissoesContext = React.createContext<Record<string, boolean>>({});

export const TelaMarkupContainer = () => {
    const nomeGrid = "PRODUTOS_MARKUP"
    const orcamento = useAppSelector((store) => store.orcamento);
    const isMounted = useRef(true);

    const [colunas, setColunas] = useState<IColuna[]>([]);
    const [tamanhoFonte, setTamanhoFonte] = useState<number>(0);
    const [dadosMarkup, setDadosMarkup] = useState<Markup>({})
    const [numeroCasasDecimaisQuantidade, setNumeroCasasDecimaisQuantidade] = useState(3)
    const [numeroCasasDecimaisPrecoCompra, setNumeroCasasDecimaisPrecoCompra] = useState(2)
    const [numeroCasasDecimaisPrecoVenda, setNumeroCasasDecimaisPrecoVenda] = useState(2)
    const [permiteEngrenagemGrid, setPermiteEngrenagemGrid] = useState(false)
    const [exibirNomeReferencia, setExibirNomeReferencia] = useState<boolean>(false)
    const [substituirMarkupPorMargem, setSubstituirMarkupPorMargem] = useState<boolean>(false)
    const [permiteInteragirMargemLucro, setPermiteInteragirMargemLucro] = useState<boolean>(false)
    const [trocarTermoMarkupPorMargemDeLucro, setTrocarTermoMarkupPorMargemDeLucrom] = useState<boolean>(false) // 444366
    const [precoMargemAlterados, setPrecoMargemAlterados] = useState<produtoMarkupAlterado[]>([])
    const [senhaMarkup, setSenhaMarkup] = useState<string>("")   
    const [markupAtualizado, setMarkupAtualizado] = useState<number>(0)
    const [processando, setProcessando] = useState<boolean>(false);
    const [permissoes, setPermissoes] = useState<Record<string, boolean>>({}) // 484771
    const requestObterMarkupSeqRef = useRef(0);
    const [simulacoesEmVoo, setSimulacoesEmVoo] = useState<number>(0);

    const atualizarParametros = useCallback(async () => {
        try {
            if (!isMounted.current) return
            const parametros_ = await obterParametros({
                nomes: [
                    "NDECPRUNIE",
                    "ORCAMENTO_MASCARA_QUANTIDADE",
                    "CASAS_DECIMAIS_PRECO_VENDA",
                    "CHAVE_MOVIMENTACAO_ORCAMENTO",
                    "SUBSTITUIR_MARKUP_POR_MARGEM",
                    "PERMITE_INTERAGIR_MARGEM_LUCRO",
                    "TROCAR_TERMO_MARKUP", // 444366
                ]
            })

            if (!isMounted.current) return;

            setExibirNomeReferencia(parametros_.find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO").Valor == "R")
            setSubstituirMarkupPorMargem(parametros_.find(p => p.Nome == "SUBSTITUIR_MARKUP_POR_MARGEM").Valor == "S")
            setPermiteInteragirMargemLucro(parametros_.find(p => p.Nome == "PERMITE_INTERAGIR_MARGEM_LUCRO").Valor == "S")
            setTrocarTermoMarkupPorMargemDeLucrom(parametros_.find(p => p.Nome == "TROCAR_TERMO_MARKUP").Valor == "S") // 444366


            setNumeroCasasDecimaisQuantidade(
                globalMU.resolverNumeroCasasDecimaisDeParametroFormatado(
                    parametros_.find(p => p.Nome == "ORCAMENTO_MASCARA_QUANTIDADE")?.Valor,
                    3
                )
            )

            let casasDecimaisPrecoVenda = Number(parametros_.find(p => p.Nome == "CASAS_DECIMAIS_PRECO_VENDA").Valor)
            if (isNaN(casasDecimaisPrecoVenda)) {
                casasDecimaisPrecoVenda = 2;
            }
            setNumeroCasasDecimaisPrecoVenda(casasDecimaisPrecoVenda)

            let casasDecimaisPrecoCompra = Number(parametros_.find(p => p.Nome == "NDECPRUNIE").Valor)
            if (isNaN(casasDecimaisPrecoCompra)) {
                casasDecimaisPrecoCompra = 2;
            }
            /*
            setNumeroCasasDecimaisPrecoCompra(
                Number(parametros_.find(p => p.Nome == "NDECPRUNIE").Valor)
            )
                */
            setNumeroCasasDecimaisPrecoCompra(casasDecimaisPrecoCompra)
        } catch (error) {
            if (isMounted.current) {
                tratamentoErroPadrao(error);
            }
        }
    }, [])

    const atualizarPermissoes = useCallback(async () => {
        const permissoesMap: Record<string, boolean> = {}; // 484771
        // Lista de todas as permissões de totalizadores
        permissoesMap["TOTALIZADOR_MARGEM_LUCRO_ANTERIOR"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARGEM_LUCRO_ANTERIOR" });// 484771
        permissoesMap["TOTALIZADOR_MARKUP_ANTERIOR"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARKUP_ANTERIOR" });
        permissoesMap["TOTALIZADOR_MARGEM_LUCRO_ZERO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARGEM_LUCRO_ZERO" });
        permissoesMap["TOTALIZADOR_MARKUP_MARGEM_ZERO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARKUP_MARGEM_ZERO" }); // 492101
        permissoesMap["TOTALIZADOR_MARKUP_DA_ULTIMA_PESQUISA"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARKUP_DA_ULTIMA_PESQUISA" });
        permissoesMap["TOTALIZADOR_CUSTO_DA_ULTIMA_PESQUISA"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_CUSTO_DA_ULTIMA_PESQUISA" });
        permissoesMap["TOTALIZADOR_MK_PREÇO_DE_VENDA_E_CUSTO_DA_ULTIMA_PESQUISA_DE_PREÇO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MK_PREÇO_DE_VENDA_E_CUSTO_DA_ULTIMA_PESQUISA_DE_PREÇO" });
        permissoesMap["TOTALIZADOR_MARGEM_LUCRO_ATUAL"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARGEM_LUCRO_ATUAL" });
        permissoesMap["TOTALIZADOR_MARKUP_ATUAL"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARKUP_ATUAL" });
        permissoesMap["TOTALIZADOR_MARGEM_LUCRO_REAL"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARGEM_LUCRO_REAL" });
        permissoesMap["TOTALIZADOR_MARKUP_REAL"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARKUP_REAL" });
        permissoesMap["TOTALIZADOR_MARGEM_LUCRO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARGEM_LUCRO" });
        permissoesMap["TOTALIZADOR_PREÇO_DE_VENDA_LIQUIDO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_PREÇO_DE_VENDA_LIQUIDO" });
        permissoesMap["TOTALIZADOR_CUSTO_DO_ORÇAMENTO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_CUSTO_DO_ORÇAMENTO" });
        permissoesMap["TOTALIZADOR_MARKUP_BRUTO_A_VISTA"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARKUP_BRUTO_A_VISTA" });
        permissoesMap["TOTALIZADOR_CONTRIBUIÇAO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_CONTRIBUIÇAO" });
        permissoesMap["TOTALIZADOR_MARGEM_OU_MARKUP_BRUTO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_MARGEM_OU_MARKUP_BRUTO" });
        permissoesMap["TOTALIZADOR_COMISSAO"] = await obterPermissao({ funcionalidade: "ORCAMENTO_MARKUP", acao: "TOTALIZADOR_COMISSAO" });// 484771

        setPermissoes(permissoesMap);
    }, []);
    
    const permitidoAcaoFuncionalidade = useCallback(async (siglaFuncionalidade: string, acao?: string) => {
        return await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });
    }, []);

    const atualizarPermiteEngrenagemGrid = useCallback(async () => {
        try {
            const permite = await permitidoAcaoFuncionalidade("ORCAMENTO_ACESSO_ENGRENAGEM_GRID");
            if (isMounted.current) {
                setPermiteEngrenagemGrid(permite);
            }
        } catch (error) {
            if (isMounted.current) {
                tratamentoErroPadrao(error);
            }
        }
    }, [permitidoAcaoFuncionalidade])

    const onObterMarkup = useCallback(async (senha: string, precoMargemAlterados: produtoMarkupAlterado[] = []) => {
        const isSimulacaoIncremental = precoMargemAlterados.length > 0;
        const currentSeq = ++requestObterMarkupSeqRef.current;
        if (isSimulacaoIncremental) {
            setSimulacoesEmVoo(prev => prev + 1);
        }
        try {
            if (!isMounted.current) return
            if (!isSimulacaoIncremental) {
                globalMU.blockUI();
            }
            setSenhaMarkup(senha);

            const resposta = await microuniversoApi.Orcamento.obterMarkup(orcamento.IdentificadorOrcamento, senha, precoMargemAlterados);

            if (currentSeq !== requestObterMarkupSeqRef.current) return;

            if (!("HasErrors" in resposta) && isMounted.current) {
                setDadosMarkup(resposta);
                setMarkupAtualizado(prev => prev + 1);
            }
        } catch (e) {
            if (isMounted.current) {
                tratamentoErroPadrao(e)
            }
        } finally {
            if (!isSimulacaoIncremental) {
                globalMU.unblockUI();
            } else if (isMounted.current) {
                setSimulacoesEmVoo(prev => Math.max(0, prev - 1));
            }
        }
    }, [orcamento.IdentificadorOrcamento])

    const obterDadosIniciaisGrid = useCallback(async () => {
        try {
            globalMU.blockUI();
            const dadosInicias = await microuniversoApi.Seguranca.obterDadosGrid("Orcamento", nomeGrid );
            if (isMounted.current) {
                setColunas(dadosInicias.Colunas);
                setTamanhoFonte(dadosInicias.TamanhoFonte);
            }
        } catch (e) {
            if (isMounted.current) {
                tratamentoErroPadrao(e);
            }
        } finally {
            globalMU.unblockUI();
        }
    }, []);

    const alterarFonte = useCallback(async (tamanho: number) => {
        globalMU.blockUI();
        try {
            await microuniversoApi.Usuario.alterarFonte(nomeGrid, tamanho);
            if (isMounted.current) {
                setTamanhoFonte(tamanho);
            }
        } catch (e) {
            if (isMounted.current) {
                tratamentoErroPadrao(e);
            }
        } finally {
            globalMU.unblockUI();
        }
    }, []);

    const toggleColunaSelecionada = useCallback(async (nomeColuna: string, selecionada: boolean) => {
        if (!colunas) return;
        if (!isMounted.current) return

        let coluna = { ...colunas.find((c) => c.Nome == nomeColuna) };
        coluna.Selecionada = selecionada;

        const colunas_ = substituirItemEmArray(
            colunas,
            (coluna) => coluna.Nome == nomeColuna,
            coluna
        );

        setColunas(colunas_);

        await microuniversoApi.Seguranca.atualizarColunasGrid( colunas_, nomeGrid );
    }, [colunas]);

    const toggleSelecionarTodasColunas = useCallback(async (selecionar: boolean) => {
        if (!colunas) return;
        if (!isMounted.current) return
        const colunas_ = colunas?.map(
            (c) => ({ ...c, Selecionada: selecionar } as IColuna)
        );
        setColunas(colunas_);
        await microuniversoApi.Seguranca.atualizarColunasGrid( colunas_, nomeGrid );
    }, [colunas]);

    const onAlterarPrecoAtual = useCallback((index: number, precoAtual: string) => {
        const precoAtualNumber = Number(precoAtual);
        setPrecoMargemAlterados(prev => {
            const existente = prev.find(p => p.index == index);
            if (existente) {
                return prev.map(p => p.index === index ? { ...p, margemLucro: -1, precoAtual: precoAtualNumber } : p);
            }
            return [...prev, { index, margemLucro: -1, precoAtual: precoAtualNumber }];
        });
    }, []);

    const onAlterarMargemLucro = useCallback((index: number, margemLucro: string) => {
        const margemLucroNumber = Number(margemLucro);
        setPrecoMargemAlterados(prev => {
            const existente = prev.find(p => p.index == index);
            if (existente) {
                return prev.map(p => p.index === index ? { ...p, margemLucro: margemLucroNumber, precoAtual: -1 } : p);
            }
            return [...prev, { index, margemLucro: margemLucroNumber, precoAtual: -1 }];
        });
    }, []);

    const onAplicarPrecos = useCallback(async () => {

        if (!isMounted.current || precoMargemAlterados.length < 1) {
            return;
        }
        try {
            globalMU.blockUI();

            setProcessando(true) // 435964
            const precosModificados: produtoMarkupAlterado[] = precoMargemAlterados.map(p => ({
                index: p.index,
                precoAtual: dadosMarkup.Produtos[p.index].PrecoAtual,
                margemLucro: dadosMarkup.Produtos[p.index].MargemLucro
            }));

            if (!isMounted.current) return

            const resposta = await alterarPrecoItemSimulacaoMarkup(orcamento.IdentificadorOrcamento, precosModificados);
            if (!isMounted.current) return

            if (resposta == true) {
                globalMU.showSuccessMessage("Preços aplicados com sucesso!");
                setPrecoMargemAlterados([])
            }
        } catch (e) {
            if (isMounted.current) {
                tratamentoErroPadrao(e)
            }
        } finally {
            setProcessando(false) // 435964
            globalMU.unblockUI();
        }
    }, [precoMargemAlterados, dadosMarkup, orcamento.IdentificadorOrcamento]);

    useEffect(() => {
        isMounted.current = true;
        atualizarPermissoes() // 474771
        atualizarParametros();
        obterDadosIniciaisGrid();
        atualizarPermiteEngrenagemGrid();

        return () => {
            isMounted.current = false;
        };
    }, [])

    useEffect(() => {
        if (precoMargemAlterados.length >= 1) {
            onObterMarkup(senhaMarkup, precoMargemAlterados);
        }
    }, [precoMargemAlterados])

    const telaMarkupContextValue = useMemo(() => ({
        colunas,
        markup: dadosMarkup,
        markupAtualizado,
        onToggleColunaSelecionada: toggleColunaSelecionada,
        onAlterarPrecoAtual,
        onAlterarMargemLucro,
        onAlterarFonte: alterarFonte,
        onAplicarPrecos,
        tamanhoFontePadrao: tamanhoFonte,
        onToggleSelecionarTodasColunas: toggleSelecionarTodasColunas,
        permiteEngrenagemGrid,
        mascaraPrecoCompra: numeroCasasDecimaisPrecoCompra == 0 ? 2 : numeroCasasDecimaisPrecoCompra,
        mascaraPrecoVenda: numeroCasasDecimaisPrecoVenda == 0 ? 2 : numeroCasasDecimaisPrecoVenda,
        mascaraQuantidade: numeroCasasDecimaisQuantidade,
        exibirNomeReferencia,
        substituirMarkupPorMargem,
        permiteInteragirMargemLucro,
        trocarTermoMarkupPorMargemDeLucro, // 444366
        processando, // 435964
        somenteLeitura: orcamento.SomenteLeitura, // 435964
        dadosAlterados: precoMargemAlterados.length > 0,
        simulacaoEmAndamento: simulacoesEmVoo > 0,
    }), [
        colunas,
        dadosMarkup,
        markupAtualizado,
        toggleColunaSelecionada,
        onAlterarPrecoAtual,
        onAlterarMargemLucro,
        alterarFonte,
        onAplicarPrecos,
        tamanhoFonte,
        toggleSelecionarTodasColunas,
        permiteEngrenagemGrid,
        numeroCasasDecimaisPrecoCompra,
        numeroCasasDecimaisPrecoVenda,
        numeroCasasDecimaisQuantidade,
        exibirNomeReferencia,
        substituirMarkupPorMargem,
        permiteInteragirMargemLucro,
        trocarTermoMarkupPorMargemDeLucro,
        processando,
        orcamento.SomenteLeitura,
        precoMargemAlterados.length,
        simulacoesEmVoo,
    ])

    return (
        <>
            <Breadcrumb2Container
                passos={["Markup"]}
                id="TelaMarkupContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={false}
            />

            {dadosMarkup?.Produtos?.length >= 1 ?

                <TelaMarkupContext.Provider value={telaMarkupContextValue}>
                    <PermissoesContext.Provider value={permissoes}>
                        <TelaMarkup />
                    </PermissoesContext.Provider>
                </TelaMarkupContext.Provider>

                :
                <SenhaMarkup
                    onBotaoOkClicado={onObterMarkup}
                />
            }
        </>
    )
}